import { render, staticRenderFns } from "./Barco.vue?vue&type=template&id=94d01b42&"
import script from "./Barco.vue?vue&type=script&lang=js&"
export * from "./Barco.vue?vue&type=script&lang=js&"
import style0 from "./Barco.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports